export enum ThousandSeparatorType {
	Point = 1,
	Comma = 2,
	Space = 3
}